import { type Booking, BookingStatus } from '../../../models/Scheduling'

export interface SendToast {
  title: string
  messages: string[]
}

// The status the backend returns is the only reliable outcome signal: a specific time can still come
// back as REQUESTED when approval rules apply, so the form's time mode must not drive the messaging.
export const scheduleSendToast = (booking: Booking): SendToast => {
  const name = booking.title ?? 'The meeting'
  switch (booking.status) {
    case BookingStatus.CONFIRMED:
      return { title: 'Meeting scheduled', messages: [`${name} is on your calendar.`] }
    case BookingStatus.REQUESTED:
      return { title: 'Approval requested', messages: [`${name} needs approval before it's confirmed.`] }
    default:
      return { title: 'Invitation sent', messages: [`${name} is now awaiting the client's reply.`] }
  }
}

export const rescheduleSendToast = (booking: Booking): SendToast => {
  const name = booking.title ?? 'The meeting'
  switch (booking.status) {
    case BookingStatus.CONFIRMED:
      return { title: 'Meeting rescheduled', messages: [`${name} moved to a new time.`] }
    case BookingStatus.REQUESTED:
      return { title: 'Approval requested', messages: [`${name} needs approval before the new time is confirmed.`] }
    default:
      return { title: 'Reschedule request sent', messages: ['The client can now pick a new time.'] }
  }
}
